"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var OBJECT_STYLE = {
    display: 'block',
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    overflow: 'hidden',
    pointerEvents: 'none',
    zIndex: -1,
    opacity: 0,
};
var ResizeDetector = /** @class */ (function (_super) {
    __extends(ResizeDetector, _super);
    function ResizeDetector(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isMounted: false,
        };
        _this.setDOMElement = _this.setDOMElement.bind(_this);
        _this.handleLoad = _this.handleLoad.bind(_this);
        return _this;
    }
    ResizeDetector.prototype.componentDidMount = function () {
        this.setState({
            isMounted: true,
        });
    };
    ResizeDetector.prototype.componentWillUnmount = function () {
        if (this.domElement.contentDocument) {
            this.domElement.contentDocument.defaultView.removeEventListener('resize', this.props.onResize);
        }
    };
    ResizeDetector.prototype.setDOMElement = function (domElement) {
        this.domElement = domElement;
    };
    ResizeDetector.prototype.handleLoad = function () {
        this.domElement.contentDocument.defaultView.addEventListener('resize', this.props.onResize);
    };
    ResizeDetector.prototype.render = function () {
        return (react_1.default.createElement("object", { style: OBJECT_STYLE, type: "text/html", data: this.state.isMounted ? 'about:blank' : undefined, ref: this.setDOMElement, onLoad: this.handleLoad }));
    };
    ResizeDetector.propTypes = {
        onResize: prop_types_1.default.func.isRequired,
    };
    return ResizeDetector;
}(react_1.Component));
exports.default = ResizeDetector;
